import { render, staticRenderFns } from "./NBACdetail.vue?vue&type=template&id=5460051d&scoped=true"
import script from "./NBACdetail.vue?vue&type=script&lang=js"
export * from "./NBACdetail.vue?vue&type=script&lang=js"
import style0 from "./NBACdetail.vue?vue&type=style&index=0&id=5460051d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460051d",
  null
  
)

export default component.exports